/* eslint-disable global-require */
import { createFromIconfontCN } from '@ant-design/icons';
var IconFont = createFromIconfontCN({
  scriptUrl: ['//at.alicdn.com/t/font_2038355_gdk1t82cnyc.js', '//at.alicdn.com/t/font_2038349_uawc82heyd.js' // outlined icon
  ]
});
export default IconFont; // 1. button icon，modal 叉叉， search 放大镜
// 2. tree 箭头 文件icon， 文件夹icon，实心箭头
// 3. alert图标
// 4. step
// 5. pageHeader, breadcrumb, dropdown